/** Project workflow status (manual / stored on project) */
export const PROJECT_STATUSES = ['pending', 'active', 'inactive', 'completed'];

export const PROJECT_STATUS_LABELS = {
  pending: 'Pending',
  active: 'Active',
  inactive: 'Inactive',
  completed: 'Completed',
};

/**
 * Budget utilization 0–100+ (can exceed 100% if over budget).
 * @param {number} budget - estimated budget
 * @param {number} totalSpent - all-in spend (expenses + imputed labour)
 */
export function getBudgetPercentUsed(budget, totalSpent) {
  const b = parseFloat(budget) || 0;
  if (b <= 0) return totalSpent > 0 ? 100 : 0;
  return Math.min(199, (totalSpent / b) * 100);
}

/** 'safe' | 'warn' | 'danger' — danger at >= 90% */
export function getProfitHealthVariant(percentUsed) {
  if (percentUsed >= 90) return 'danger';
  if (percentUsed >= 70) return 'warn';
  return 'safe';
}

/**
 * Split labour expenses for a project into internal team vs subcontractor.
 * Uses expense.laborOrigin: 'internal' | 'subcontractor' when category is labour; defaults internal.
 */
export function getLaborBreakdownForProject(expenses, projectId) {
  let internal = 0;
  let subcontractor = 0;
  const list = expenses.filter(
    (e) =>
      e.projectId === projectId && (e.category === 'labour' || e.category === 'labor')
  );
  for (const e of list) {
    const amt = parseFloat(e.amount) || 0;
    if (e.laborOrigin === 'subcontractor') subcontractor += amt;
    else internal += amt;
  }
  return { internal, subcontractor, total: internal + subcontractor };
}

/** Ensure nested arrays exist on a project object */
export function ensureProjectExtensions(p) {
  return {
    ...p,
    changeOrders: Array.isArray(p.changeOrders) ? p.changeOrders : [],
    dailySiteLogs: Array.isArray(p.dailySiteLogs) ? p.dailySiteLogs : [],
    sitePhotos: Array.isArray(p.sitePhotos) ? p.sitePhotos : [],
    vaultDocuments: Array.isArray(p.vaultDocuments) ? p.vaultDocuments : [],
    projectStatus: p.projectStatus || 'active',
  };
}
